import React, { useEffect } from "react";
import "./App.css";
import MainRoutesComp from "./routes/routes";
import "bootstrap/dist/css/bootstrap.min.css";
import { EventEmitter } from "events";
import { useLocation } from "react-router-dom";
import "./i18n";
import BhashiniLoader from "./utils/BhashiniLoader";

export const event = new EventEmitter();

const LOGOUT_REDIRECT_URL = process.env.REACT_APP_LOGOUT_REDIRECT_URL;

function App() {
  const location = useLocation();

  // :white_check_mark: Logout handler
  React.useEffect(() => {
    const handleLogout = () => {
      localStorage.clear();
      window.location.href = LOGOUT_REDIRECT_URL;
    };

    event.on("logout", handleLogout);
    return () => {
      event.off("logout", handleLogout);
    };
  }, []);

  // :white_check_mark: Clear storage
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("clearStorage") === "true") {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user");
      localStorage.removeItem("otp_mobile");

      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  // :rocket: Deep Link Handling (PATH BASED)
  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;

    const isAndroid = /android/i.test(ua);
    const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;

    const androidStore =
      "https://play.google.com/store/apps/details?id=com.khelotech.khelouk";

    const iosStore =
      "https://apps.apple.com/in/app/fit-uttarakhand/id6749542220";

    const currentUrl = window.location.href;
    const path = window.location.pathname;

    // :white_check_mark: Define restricted paths
    const restrictedPaths = ["/news", "/gallery", "/shorts"];

    const isRestricted = restrictedPaths.some((p) =>
      path.startsWith(p)
    );

    // :x: If not restricted → DO NOTHING
    if (!isRestricted) return;

    // :robot_face: ANDROID

    if (isAndroid) {
      let appOpened = false;

      const intentUrl =
        "intent://" +
        currentUrl.replace(/^https?:\/\//, "") +
        "#Intent;" +
        "scheme=https;" +
        "package=com.khelotech.khelouk;" +
        "end;";

      const handleVisibilityChange = () => {
        if (document.hidden) {
          appOpened = true;
        }
      };

      document.addEventListener(
        "visibilitychange",
        handleVisibilityChange
      );

      // Try opening app
      window.location.href = intentUrl;

      // Fallback to Play Store
      setTimeout(() => {
        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange
        );

        if (!appOpened) {
          window.location.href = androidStore;
        }
      }, 2000);
    }

    // :green_apple: iOS

    else if (isIOS) {
      setTimeout(() => {
        window.location.href = iosStore;
      }, 1500);
    }
  }, [location.pathname]);

  return (
    <>
      <BhashiniLoader />
      <MainRoutesComp />
    </>
  );
}

export default App;